module.exports = __webpack_public_path__ + "static/media/ICICI_Prudential_Mutual_Fund.fe345807.pdf";